export default "__VITE_ASSET__DVLTU7dc__"